
/**
 * https://domain1.icode.org.cn        -> https://domain2.icode.org.cn 
 * https://domain1-test.icode.org.cn        -> https://domain2-test.icode.org.cn 
 * https://domain1.icode4good.com        -> https://domain2.icode4good.com 
 */

export function getUrl(domain1, domain2) {
    // 临时使用
    if(window.location.origin == "https://home.icode4good.com" && domain2 === "ide") {
        return "https://ide.icode.org.cn";
    }
    if(window.location.origin == "https://c.icode4good.com" && domain2 === "ide") {
        return "https://ide.icode.org.cn";
    }

    let domainNames = window.location.origin.split('.');
    domainNames[0] = domainNames[0].replace(domain1, domain2);
    return domainNames.join(".");    
}

const domain2 = "home"; // todo set as process.env

export function getIDEurl() {
    // 临时使用
    if(window.location.origin == "https://home.icode4good.com") {
        return "https://ide.icode.org.cn";
    }

    // *.icode.org.cn  ->  ['ide', 'icode', 'org', 'cn']
    let domainNames = window.location.origin.split('.');
    domainNames[0] = domainNames[0].replace(domain2, "ide");
    return domainNames.join(".");
}

/**
 * https://home.icode.org.cn -> https://c.icode.org.cn 
 * https://home2.icode.org.cn -> https://c2.icode.org.cn -> https://home2.icode.org.cn
 * https://home.icode4good.com -> https://c.icode4good.com
 */
export function getContestUrl() {
    // domain2.icode.org.cn  ->  ['c', 'icode', 'org', 'cn']
    let domainNames = window.location.origin.split('.');
    domainNames[0] = domainNames[0].replace(domain2, "c");
    return domainNames.join(".");
}


// WEBPACK FOOTER //
// ./src/utils/domain.js